var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgItemsNotFoundIco(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 134,
    height: 71,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 1)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.383 0C131.485 0 134 2.507 134 5.6c0 3.093-2.515 5.6-5.617 5.6H96.287c3.102 0 5.617 2.507 5.617 5.6 0 3.093-2.515 5.6-5.617 5.6h17.653c3.102 0 5.617 2.507 5.617 5.6 0 3.093-2.515 5.6-5.617 5.6h-8.163c-3.912 0-7.082 2.507-7.082 5.6 0 2.062 1.604 3.929 4.814 5.6 3.102 0 5.617 2.507 5.617 5.6 0 3.093-2.515 5.6-5.617 5.6H36.91c-3.102 0-5.617-2.507-5.617-5.6 0-3.093 2.515-5.6 5.617-5.6H5.617C2.515 44.8 0 42.293 0 39.2c0-3.093 2.515-5.6 5.617-5.6h32.096c3.102 0 5.616-2.507 5.616-5.6 0-3.093-2.514-5.6-5.616-5.6h-20.06c-3.102 0-5.617-2.507-5.617-5.6 0-3.093 2.515-5.6 5.617-5.6h32.096c-3.103 0-5.617-2.507-5.617-5.6 0-3.093 2.514-5.6 5.617-5.6h78.634zm0 22.4c3.102 0 5.617 2.507 5.617 5.6 0 3.093-2.515 5.6-5.617 5.6s-5.617-2.507-5.617-5.6c0-3.093 2.515-5.6 5.617-5.6z",
    fill: "#ECF3F8"
  }), /*#__PURE__*/React.createElement("ellipse", {
    stroke: "#125987",
    strokeWidth: 2.5,
    fill: "#F3F7FF",
    cx: 58.954,
    cy: 27.878,
    rx: 26.954,
    ry: 26.878
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.635 48.733a24.77 24.77 0 004.319.407c11.776 0 21.322-9.52 21.322-21.262 0-11.743-9.546-21.262-21.322-21.262-3.025 0-5.903.628-8.51 1.761a21.381 21.381 0 00-10.482 9.826 21.123 21.123 0 00-2.33 9.675c0 3.161.692 6.161 1.933 8.858a21.28 21.28 0 003.445 5.26",
    stroke: "#125987",
    strokeWidth: 2.5,
    fill: "#FFF",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.515 44.386a21.314 21.314 0 005.796 3.347",
    stroke: "#125987",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.356 13.035c-1.386 0-2.729.184-4.005.529-6.5 1.755-11.282 7.678-11.282 14.715",
    stroke: "#859FB0",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#125987",
    strokeWidth: 2.5,
    d: "M81.08 49.14l4.828 4.813"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.884 52.284a3.645 3.645 0 012.587 1.067h0l8.92 8.894a3.623 3.623 0 011.068 2.569c0 .93-.353 1.86-1.059 2.569a3.67 3.67 0 01-2.594 1.078 3.645 3.645 0 01-2.588-1.068h0L85.3 58.499a3.623 3.623 0 01-1.068-2.569 3.621 3.621 0 011.059-2.569 3.67 3.67 0 012.594-1.077z",
    stroke: "#125987",
    strokeWidth: 2.5,
    fill: "#E8F0FE"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    d: "M89.126 54.756l8.851 8.825"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.286 21.755H93.265m19.735 0h-1.813m-9.064 5.868H95.45M26.222 38.778h-13.88m-4.706 0h-3.41M30 45.611h-6.607",
    stroke: "#859FB0",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
export default SvgItemsNotFoundIco;